import { render, staticRenderFns } from "./FloatingContentPanel.vue?vue&type=template&id=7c38f4f1&scoped=true&"
import script from "./FloatingContentPanel.vue?vue&type=script&lang=js&"
export * from "./FloatingContentPanel.vue?vue&type=script&lang=js&"
import style0 from "./FloatingContentPanel.vue?vue&type=style&index=0&id=7c38f4f1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c38f4f1",
  null
  
)

export default component.exports